(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lineup-runway"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lineup-runway')) {
  customElements.define(
    'lineup-runway',
    class LineupRunway extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
        this._init = false;
      }

      q(sel, root) { return (root || this).querySelector(sel); }
      qa(sel, root) { return Array.prototype.slice.call((root || this).querySelectorAll(sel)); }

      init() {
        if (this._init) return;
        this.models = this.qa('[data-lu-model]');
        if (!this.models.length) return;
        this._init = true;

        this.catalogue = this.q('[data-lu-catalogue]');
        this.panelGrid = this.q('[data-lu-panel-grid]');
        this.design = this.dataset.design === 'true';
        this.autoplayOn = this.dataset.autoplayEnabled !== 'false';
        this.duration = Math.max(2000, (parseFloat(this.dataset.autoplay) || 5.5) * 1000);
        this.reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.active = 0;
        this.colour = {};
        this.paused = false;

        this.looks = this.models.map((el, i) => {
          const colours = [1, 2, 3]
            .map((n) => ({ n: el.dataset['c' + n + 'n'] || '', h: el.dataset['c' + n + 'h'] || '#cccccc', src: el.dataset['src' + n] || '' }))
            .filter((c, idx) => idx === 0 || c.src);
          return { name: el.dataset.name || 'Look ' + (i + 1), colours: colours };
        });

        this.bind();
        this.setActive(0);
        this.q('[data-lu-nav]').hidden = this.looks.length < 2;
        this.resetAuto();
      }

      bind() {
        const prev = this.q('[data-lu-prev]');
        const next = this.q('[data-lu-next]');
        if (prev) prev.addEventListener('click', () => this.setActive(this.active - 1, true));
        if (next) next.addEventListener('click', () => this.setActive(this.active + 1, true));

        // shop button: scroll to catalogue when it points to the in-page anchor
        this.qa('[data-lu-shop]').forEach((btn) => {
          btn.addEventListener('click', (e) => {
            const href = btn.getAttribute('href') || '';
            if (href.indexOf('#lu-catalogue-') === 0) {
              e.preventDefault();
              const t = document.getElementById(href.slice(1));
              if (t) t.scrollIntoView({ behavior: this.reduced ? 'auto' : 'smooth', block: 'start' });
            }
          });
        });

        // clicking a model: back looks come forward, the front look triggers the shop button
        this.models.forEach((el, i) => {
          const btn = this.q('.lu-model-btn', el);
          if (!btn) return;
          btn.addEventListener('click', () => {
            if (Number(el.getAttribute('data-slot')) === 0) {
              const shop = this.q('[data-lu-shop]');
              if (shop) shop.click();
            } else {
              this.setActive(i, true);
            }
          });
        });

        // colour swatches (delegated)
        this.q('[data-lu-swatches]').addEventListener('click', (e) => {
          const b = e.target.closest('.lu-sw');
          if (b) this.setColour(Number(b.getAttribute('data-i')));
        });

        // autoplay pause / resume
        const wrap = this.q('[data-lu-stage-wrap]');
        const pause = () => { this.paused = true; clearTimeout(this.timer); };
        const resume = () => { this.paused = false; this.resetAuto(); };
        wrap.addEventListener('mouseenter', pause);
        wrap.addEventListener('mouseleave', resume);
        wrap.addEventListener('focusin', pause);
        wrap.addEventListener('focusout', resume);

        // swipe
        let sx = 0;
        let sy = 0;
        wrap.addEventListener('touchstart', (e) => { pause(); sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
        wrap.addEventListener('touchend', (e) => {
          const dx = e.changedTouches[0].clientX - sx;
          const dy = e.changedTouches[0].clientY - sy;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) this.setActive(this.active + (dx < 0 ? 1 : -1), true);
          resume();
        }, { passive: true });

        this.onVisibility = () => { if (document.hidden) pause(); else resume(); };
        document.addEventListener('visibilitychange', this.onVisibility);

        // keyboard
        this.addEventListener('keydown', (e) => {
          if (/^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) return;
          if (e.key === 'ArrowRight') this.setActive(this.active + 1, true);
          if (e.key === 'ArrowLeft') this.setActive(this.active - 1, true);
        });

        // Shopify theme editor: selecting a look / product block jumps to that look
        this.addEventListener('shopify:block:select', (e) => {
          let idx = this.models.indexOf(e.target.closest('[data-lu-model]'));
          if (idx < 0) {
            const card = e.target.closest('[data-look]');
            if (card) idx = Number(card.getAttribute('data-look')) - 1;
          }
          if (idx >= 0 && idx < this.models.length) this.setActive(idx);
        });
      }

      updateSlots() {
        const n = this.models.length;
        this.models.forEach((el, i) => {
          const rel = (i - this.active + n) % n;
          const slot = Math.min(rel, 5);
          el.setAttribute('data-slot', String(slot));
          el.setAttribute('aria-hidden', slot === 5 && n > 1 ? 'true' : 'false');
          const btn = this.q('.lu-model-btn', el);
          if (btn) btn.tabIndex = slot === 5 && n > 1 ? -1 : 0;
        });
      }

      renderControls() {
        const look = this.looks[this.active];
        const ci = this.colour[this.active] || 0;
        const col = look.colours[ci];
        const pad = (v) => String(v).padStart(2, '0');

        this.q('[data-lu-look-name]').textContent = look.name;
        this.q('[data-lu-counter]').textContent = pad(this.active + 1) + ' / ' + pad(this.looks.length);

        const segs = this.q('[data-lu-segs]');
        segs.textContent = '';
        this.looks.forEach((_, i) => {
          const s = document.createElement('span');
          s.className = 'lu-seg' + (i === this.active ? ' is-on' : '');
          segs.appendChild(s);
        });

        const pill = this.q('.lu-swatch-pill');
        pill.hidden = look.colours.length < 2;
        this.q('[data-lu-colour-name]').textContent = col.n;
        const sw = this.q('[data-lu-swatches]');
        sw.textContent = '';
        look.colours.forEach((c, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'lu-sw' + (i === ci ? ' is-on' : '');
          b.style.background = c.h;
          b.setAttribute('data-i', String(i));
          b.setAttribute('aria-label', c.n || 'Colour ' + (i + 1));
          sw.appendChild(b);
        });
      }

      renderPanel() {
        if (!this.catalogue || !this.panelGrid) return;
        const cards = this.qa('[data-lu-product-card]', this.catalogue).filter(
          (c) => Number(c.getAttribute('data-look')) === this.active + 1
        );
        this.panelGrid.textContent = '';
        cards.forEach((c) => {
          const clone = c.cloneNode(true);
          clone.removeAttribute('data-shopify-editor-block');
          this.panelGrid.appendChild(clone);
        });
        this.q('[data-lu-panel-meta]').textContent = cards.length + (cards.length === 1 ? ' piece' : ' pieces');
      }

      setActive(i, manual) {
        const n = this.looks.length;
        this.active = ((i % n) + n) % n;
        this.updateSlots();
        this.renderControls();
        this.renderPanel();
        if (manual) this.resetAuto();
      }

      setColour(i) {
        this.colour[this.active] = i;
        const img = this.q('img', this.models[this.active]);
        const src = this.looks[this.active].colours[i].src;
        if (img && src) {
          img.style.opacity = '0';
          const pre = new Image();
          const swap = () => { img.src = src; img.style.opacity = ''; };
          pre.onload = swap;
          pre.onerror = swap;
          pre.src = src;
        }
        this.renderControls();
      }

      resetAuto() {
        clearTimeout(this.timer);
        if (this.design || this.reduced || this.paused || document.hidden || !this.autoplayOn || this.looks.length < 2) return;
        this.timer = setTimeout(() => {
          this.setActive(this.active + 1);
          this.resetAuto();
        }, this.duration);
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();
})();
